import React from "react";
import { Box, Container, Typography, Grid, Divider, Stack } from "@mui/material";
import { NavLink } from "react-router-dom";
import { BRAND } from "../theme";

const SECCIONES = [
  { label: "Economía",  to: "/economia" },
  { label: "Trabajo",   to: "/trabajo" },
  { label: "Salud",     to: "/salud" },
  { label: "Migración", to: "/migracion" },
  { label: "Seguridad", to: "/seguridad" },
];

const PLATAFORMA = [
  { label: "Inicio",   to: "/" },
  { label: "Contacto", to: "/contacto" },
];

const FUENTES = [
  "Banco Central de Chile",
  "INE",
  "FONASA · Superintendencia de Salud",
  "SERMIG · PDI",
  "CEAD · ENUSC",
];

const FRANJA = `linear-gradient(90deg,
  ${BRAND.nodoBlue} 0%, ${BRAND.nodoBlue} 72%,
  ${BRAND.fesRed} 72%, ${BRAND.fesRed} 90%,
  ${BRAND.fesYellow} 90%, ${BRAND.fesYellow} 100%)`;

function TituloColumna({ children }) {
  return (
    <Typography
      sx={{
        fontWeight: 700,
        mb: 2,
        fontSize: "0.72rem",
        letterSpacing: "0.14em",
        textTransform: "uppercase",
        color: "rgba(255,255,255,0.55)",
      }}
    >
      {children}
    </Typography>
  );
}

function LinkFooter({ to, children }) {
  return (
    <Box
      component={NavLink}
      to={to}
      sx={{
        display: "inline-block",
        mb: 1,
        color: "rgba(255,255,255,0.82)",
        fontSize: "0.88rem",
        textDecoration: "none",
        transition: "color 0.15s ease",
        "&:hover": {
          color: "#fff",
          textDecoration: "underline",
          textDecorationColor: BRAND.fesYellow,
          textUnderlineOffset: "4px",
        },
      }}
    >
      {children}
    </Box>
  );
}

export default function Footer() {
  return (
    <Box component="footer" sx={{ mt: 10 }}>
      <Box aria-hidden sx={{ height: 3, background: FRANJA }} />
      <Box
        sx={{
          background: `linear-gradient(180deg, ${BRAND.nodoBlueDk} 0%, ${BRAND.nodoNavy} 100%)`,
          color: "#fff",
          pt: { xs: 6, md: 7 },
          pb: 3.5,
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 4, md: 6 }}>
            {/* Marca + descripción + logos */}
            <Grid size={{ xs: 12, md: 5 }}>
              <Box sx={{ mb: 2.5 }}>
                <Box
                  component="img"
                  src="/img/logo-texto-claro.png"
                  alt="Datos para la Democracia"
                  sx={{ height: 44, width: "auto", display: "block", objectFit: "contain" }}
                />
              </Box>
              <Typography
                variant="body2"
                sx={{ color: "rgba(255,255,255,0.72)", lineHeight: 1.75, maxWidth: 380, mb: 3 }}
              >
                Plataforma de datos públicos para la democracia, desarrollada por
                Fundación Nodo XXI con el apoyo de Friedrich-Ebert-Stiftung (FES Chile).
              </Typography>
              <Stack direction="row" spacing={2} alignItems="center">
                <Box
                  component="img"
                  src="/img/Logo_NODO_BLANCO.png"
                  alt="Fundación Nodo XXI"
                  sx={{ height: 42, objectFit: "contain", opacity: 0.95 }}
                />
                {/* El logo FES es una imagen con fondo rojo sólido (sin transparencia);
                    se monta sobre una tarjeta blanca para que conserve sus colores. */}
                <Box sx={{ bgcolor: "#fff", borderRadius: 1.5, px: 1.25, py: 0.75, lineHeight: 0 }}>
                  <Box
                    component="img"
                    src="/img/FES-Logo_Standard_Rot_Bildschirm.png"
                    alt="Friedrich-Ebert-Stiftung"
                    sx={{ height: 30, objectFit: "contain", display: "block" }}
                  />
                </Box>
              </Stack>
            </Grid>

            {/* Secciones */}
            <Grid size={{ xs: 6, sm: 4, md: 2.5 }}>
              <TituloColumna>Secciones</TituloColumna>
              <Stack alignItems="flex-start">
                {SECCIONES.map((l) => (
                  <LinkFooter key={l.to} to={l.to}>{l.label}</LinkFooter>
                ))}
              </Stack>
            </Grid>

            {/* Plataforma */}
            <Grid size={{ xs: 6, sm: 4, md: 2 }}>
              <TituloColumna>Plataforma</TituloColumna>
              <Stack alignItems="flex-start">
                {PLATAFORMA.map((l) => (
                  <LinkFooter key={l.to} to={l.to}>{l.label}</LinkFooter>
                ))}
              </Stack>
            </Grid>

            {/* Fuentes oficiales */}
            <Grid size={{ xs: 12, sm: 4, md: 2.5 }}>
              <TituloColumna>Fuentes oficiales</TituloColumna>
              <Stack spacing={1}>
                {FUENTES.map((f) => (
                  <Typography key={f} sx={{ color: "rgba(255,255,255,0.6)", fontSize: "0.82rem", lineHeight: 1.5 }}>
                    {f}
                  </Typography>
                ))}
              </Stack>
            </Grid>
          </Grid>

          <Divider sx={{ borderColor: "rgba(255,255,255,0.14)", my: 3.5 }} />

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.55)" }}>
              © {new Date().getFullYear()} Fundación Nodo XXI · datosparalademocracia.cl
            </Typography>
            <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.55)" }}>
              Elaborado por Fundación Nodo XXI con apoyo de FES Chile
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
